<template>
  <div>
    <ETooltip
      v-if="!isMobileDisplay"
      v-analytics.mouseover="trackAdPillTooltipShown('desktop')"
      class="ad-pill-tooltip"
      :side="tooltipSide"
    >
      <span
        ref="label"
        class="ad-pill-tooltip__label"
        data-test-id="ad-result-label"
      >
        <slot>
          {{ $t("common.search.ad") }}
        </slot>
      </span>
      <template #content>
        <div class="ad-pill-tooltip__content">
          {{ $t('common.search.ad.tooltip.text') }}
          <div class="ad-pill-tooltip__links">
            <EAdLabelLearnMoreLink
              v-analytics.click="trackAdPillTooltipClick('learn_more')"
              class="ad-pill-tooltip__learn-more-link"
              @click="onLearnMoreClick"
            />
            <EAdLabelReportLink
              v-analytics.click="trackAdPillTooltipClick('report_ad')"
              class="ad-pill-tooltip__report-link"
              @click="$emit('report-clicked')"
            />
          </div>
        </div>
      </template>
    </ETooltip>
    <span
      v-if="isMobileDisplay"
      ref="label"
      v-analytics.click="trackAdPillTooltipShown('mobile')"
      class="ad-pill-tooltip__label"
      data-test-id="ad-result-label-mobile"
      @click.prevent="onMobileLabelClick"
      @keydown.enter="onMobileLabelClick"
      @keydown.space="onMobileLabelClick"
    >
      <slot>
        {{ $t("common.search.ad") }}
      </slot>
    </span>
    <EAdLabelModal
      v-if="isMobileDisplay"
      :active="modalActive"
      @close="onModalClose"
    >
      <template #content>
        {{ $t('common.search.ad.tooltip.text') }}
        <div class="ad-pill-tooltip__links">
          <EAdLabelLearnMoreLink
            v-analytics.click="trackAdPillTooltipClick('learn_more')"
            class="ad-pill-tooltip__learn-more-link"
            @click="onLearnMoreClick"
          />
          <EAdLabelReportLink
            v-analytics.click="trackAdPillTooltipClick('report_ad')"
            class="ad-pill-tooltip__report-link"
            @click="$emit('report-clicked')"
          />
        </div>
      </template>
    </EAdLabelModal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ETooltip from '~~/common/vue/components/tooltip';
import EAdLabelModal from './modal';
import EAdLabelLearnMoreLink from './learn-more-link';
import EAdLabelReportLink from './report-link';
import screen from '~~/common/vue/mixins/screen';
import {
  trackAdPillTooltipShown,
  trackAdPillTooltipClick,
} from '~~/search/common/js/client/analytics/ad-quality-feedback';

export default {
  name: 'EAdLabel',
  components: {
    ETooltip,
    EAdLabelModal,
    EAdLabelLearnMoreLink,
    EAdLabelReportLink,
  },
  mixins: [screen],
  props: {
    tooltipSide: ETooltip.props.side,
  },
  data() {
    return {
      modalActive: false,
      trackAdPillTooltipShown,
      trackAdPillTooltipClick,
    };
  },
  computed: {
    ...mapState('global', ['locale']),
    isMobileDisplay() {
      return !this.isMobileLargeUp;
    },
  },
  methods: {
    onLearnMoreClick() {
      this.$refs.label.focus();
    },
    onMobileLabelClick() {
      this.modalActive = true;
    },
    onModalClose() {
      this.modalActive = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.ad-pill-tooltip__label {
  color: var(--color-text-secondary);
  font-weight: $font-weight-1l;
}

// note: this is only temporary until end of experiment CS-664
.ad-pill-tooltip__label--regular {
  .ad-pill-tooltip__label {
    font-weight: $font-weight-m;
  }
}

.ad-pill-tooltip__content {
  display: flex;
  flex-direction: column;
  gap: $space-3s;
}

.ad-pill-tooltip__links {
  display: flex;
  flex-direction: row;
}

.ad-pill-tooltip__learn-more-link {
  margin-right: $space-m;
}
</style>
